export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          background: #222222;
        }
        #root {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          height: 100%;
          min-height: 100%;
          overflow-x: hidden;
          user-select: none;
          width: 100%;
        }
        .user-block {
          background: linear-gradient(180deg, #ffffffd6, #ffffff54);
          border-radius: 4px;
          color: #000000b3;
          padding-left: 4px;
          padding-right: 4px;
          width: 180px;
        }
        .user-block__value {
          font-weight: bold;
        }
      `,
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "rgb(0 0 0)"
        }
      }
    },
  },
  typography: {
    muted: {
      opacity: '.6',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#80dbff',
    },
    secondary: {
      main: '#cacaca',
    },
    toolbar: {
      main: '#ffffff',
    }
  },
}
